import { processingGroupIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const createProcessingGroup = {
  name: "createProcessingGroup" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ id: processingGroupIdFormat.schema }),
};
